import request from "@/utils/request";
export function getPage(condition, pagination) {
  return request({
    url: "/product/mountings/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
export function get(id) {
  return request({
    url: "/product/mountings/get",
    method: "get",
    params: { id },
  });
}
export function updateInventory(data) {
  return request({
    url: "/product/mountings/updateInventory",
    method: "post",
    data
  });
}
export function getPagePopup(condition, pagination) {
  return request({
    url: "/product/mountings/pagePopup",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
// }返回产值
export function outsourcePagePopup(condition, pagination) {
  return request({
    url: "/product/mountings/outsourcePagePopup",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
export function getSparePartsApi(condition, pagination) {
  return request({
    url: "/product/mountings/pageList",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
export function saveOrUpdate(data) {
  return request({
    url: "/product/mountings/saveOrUpdate",
    method: "post",
    data,
  });
}

